import { FieldType, FormGetFieldValueFn } from '@/form/FormProvider';

interface UseBmiValues {
  units: FieldType | undefined;
  height: FieldType | undefined;
  weight: FieldType | undefined;
  weightSt: FieldType | undefined;
  weightLb: FieldType | undefined;
  heightFt: FieldType | undefined;
  heightIn: FieldType | undefined;
}

export const useBmiValues = (getFieldValue: FormGetFieldValueFn): UseBmiValues => {
  // Units (GB)
  const units = getFieldValue('units');

  // Metrics
  const weight = getFieldValue('weight');
  const height = getFieldValue('height');

  // Retardunits
  const weightSt = getFieldValue('weightSt');
  const weightLb = getFieldValue('weightLb');
  const heightFt = getFieldValue('heightFt');
  const heightIn = getFieldValue('heightIn');

  return { units, height, weight, weightSt, weightLb, heightFt, heightIn };
};
